import {
  GET_WORK_FLOW,
  GET_WORK_FLOW_CLEAR_DATA,
  GET_WORK_FLOW_ERROR,
  GET_WORK_FLOW_SUCCESS,
  START_WORK_FLOW,
  START_WORK_FLOW_CLEAR_DATA,
  START_WORK_FLOW_ERROR,
  START_WORK_FLOW_SUCCESS,
} from "./actionTypes";

export const getWorkFlow = (wf, history) => {
  return {
    type: GET_WORK_FLOW,
    payload: { wf, history },
  };
};

export const getWorkFlowSuccess = (success) => {
  return {
    type: GET_WORK_FLOW_SUCCESS,
    payload: success,
  };
};

export const getWorkFlowError = (error) => {
  return {
    type: GET_WORK_FLOW_ERROR,
    payload: error,
  };
};

export const getWorkFlowClearData = () => {
  return {
    type: GET_WORK_FLOW_CLEAR_DATA,
    payload: {},
  };
};

export const startWorkFlow = (swf, history) => {
  return {
    type: START_WORK_FLOW,
    payload: { swf, history },
  };
};

export const startWorkFlowSuccess = (success) => {
  return {
    type: START_WORK_FLOW_SUCCESS,
    payload: success,
  };
};

export const startWorkFlowError = (error) => {
  return {
    type: START_WORK_FLOW_ERROR,
    payload: error,
  };
};

export const startWorkFlowClearData = () => {
  return {
    type: START_WORK_FLOW_CLEAR_DATA,
    payload: {},
  };
};
